<template>
    <Link :href="link" :class="['bb-nav-link w-full px-7 mx-1 linky anim relative font-normal py-0 bg-primary-light text-gray-100 flex flex-col justify-center items-center whitespace-nowrap', {'active': $page.component === component}]">
        <img v-if="icon" :src="getIcon()" class="z-20 icon w-6 h-6 origin-center" aria-hidden="true" alt="l.label" />
        <img v-if="icon" :src="getIcon()" class="shadow z-10 w-10 h-2 origin-center mb-2" aria-hidden="true" alt="l.label" />
        <div class="label pl-0 text-sm font-bold uppercase text-center">
            {{ label }}
        </div>
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/vue3';

    export default {
        name: "BasketballNavigationLink",
        components: { Link },
        props: ['link', 'label', 'icon', 'component'],
        computed: {},
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            getIcon() {
                if(this.icon?.indexOf('http') > -1) {
                    return this.icon;
                }else{
                    return `/images/icons/${this.icon}`;
                }
            }
        }
    }
</script>
<style lang="css">
.bb-nav-link {
    transition: all .35s cubic-bezier(0.075, 0.82, 0.165, 1);
    box-shadow: inset 4px 4px 6px rgba(100,100,100,.1);
    border-radius: 15px;
    position: relative;
    height: 45px;
    margin-top: 16px;
}
.bb-nav-link .label {
    text-shadow: -2px -2px 2px rgba(0, 0, 0, .7), 2px 2px 2px rgba(0, 0, 0, .7);
}
.bb-nav-link .icon {
    transition: transform .35s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: rotate(0) translateY(-4px);
}
.bb-nav-link .shadow {
    position: absolute;
    bottom: 16px;
    transition: all .35s cubic-bezier(0.075, 0.82, 0.165, 1);
    filter: brightness(0) blur(2px);
    opacity: 0;
}

.bb-nav-link:hover,
.bb-nav-link.active {
    background-color: hsl(33, 80%, 66%);
    box-shadow: inset 3px 3px 4px rgba(0,0,0,.5), inset -2px -2px 4px rgba(20,20,20,.4);

}
.bb-nav-link:hover .icon,
.bb-nav-link.active .icon,
.bb-nav-link:hover .icon {
     transform: scale(1.8) rotate(5deg) translateY(-2px);
}
.bb-nav-link:hover .shadow,
.bb-nav-link.active .shadow,
.bb-nav-link:hover .shadow {
    transform: rotate(5px) translateY(40px) scaleX(2);
    filter: brightness(0) blur(4px);
    opacity: .3;
}
.bb-nav-link:hover .label,
.bb-nav-link.active .label,
.bb-nav-link:hover .label {
    color: rgba(0,0,0,.8);
    text-shadow: -1px -1px 2px rgba(250,250,250, .7), 1px 1px 2px rgba(250,250,250, .7);
}
</style>
